import { call, put, takeEvery } from 'redux-saga/effects'
import * as commonAppActions from '@redux/ducks/common/commonApp.Ducks'
import * as commonAppApi from '@apis/common/commonApp.Api'

interface FetchSaga {
  type: string
  payload: string
}

// ChiNhanh sagas
function* fetchListChiNhanh({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof commonAppApi.getListChiNhanh> = yield call(commonAppApi.getListChiNhanh, queryString)
    yield put(commonAppActions.getListChiNhanhSuccess(res))
  } catch (error) {
    yield put(commonAppActions.getListChiNhanhFail(error))
  }
}

function* fetchDetailChiNhanh({ payload: id }: FetchSaga) {
  try {
    const res: ReturnType<typeof commonAppApi.getDetailChiNhanh> = yield call(commonAppApi.getDetailChiNhanh, id)
    yield put(commonAppActions.getDetailChiNhanhSuccess(res))
  } catch (error) {
    yield put(commonAppActions.getDetailChiNhanhFail(error))
  }
}

// DuAn sagas
function* fetchListDuAn({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof commonAppApi.getListDuAn> = yield call(commonAppApi.getListDuAn, queryString)
    yield put(commonAppActions.getListDuAnSuccess(res))
  } catch (error) {
    yield put(commonAppActions.getListDuAnFail(error))
  }
}

function* fetchDetailDuAn({ payload: id }: FetchSaga) {
  try {
    const res: ReturnType<typeof commonAppApi.getDetailDuAn> = yield call(commonAppApi.getDetailDuAn, id)
    yield put(commonAppActions.getDetailDuAnSuccess(res))
  } catch (error) {
    yield put(commonAppActions.getDetailDuAnFail(error))
  }
}

interface FetchHeThongSaga {
  type: string
  payload: {
    queryString?: string
    id?: string
  }
}

// HeThong sagas
function* fetchListHeThong({ payload }: FetchHeThongSaga) {
  try {
    const res: ReturnType<typeof commonAppApi.getListHeThong> = yield call(commonAppApi.getListHeThong, payload.queryString)
    yield put(commonAppActions.getListHeThongSuccess(res))
  } catch (error) {
    yield put(commonAppActions.getListHeThongFail(error))
  }
}

function* fetchDetailHeThong({ payload }: FetchHeThongSaga) {
  const id = String(payload.id)
  try {
    const res: ReturnType<typeof commonAppApi.getDetailHeThong> = yield call(commonAppApi.getDetailHeThong, id)
    yield put(commonAppActions.getDetailHeThongSuccess(res))
  } catch (error) {
    yield put(commonAppActions.getDetailHeThongFail(error))
  }
}

export default function* watchCommonApp() {
  // ChiNhanh watchers
  yield takeEvery(commonAppActions.getListChiNhanh.toString(), fetchListChiNhanh)
  yield takeEvery(commonAppActions.getDetailChiNhanh.toString(), fetchDetailChiNhanh)
  
  // DuAn watchers
  yield takeEvery(commonAppActions.getListDuAn.toString(), fetchListDuAn)
  yield takeEvery(commonAppActions.getDetailDuAn.toString(), fetchDetailDuAn)
  
  // HeThong watchers
  yield takeEvery(commonAppActions.getListHeThong.toString(), fetchListHeThong)
  yield takeEvery(commonAppActions.getDetailHeThong.toString(), fetchDetailHeThong)
}

